export default import.meta.ROLLUP_FILE_URL_nLe6Yja478szmdsD082lHA